import { Reports } from "../reports"

export const LeadReports = ({ pageSwap }) => {
    return (
        <Reports
            CustomerStage={1}
            pageSwap={pageSwap}
        />)
}